import React from "react";
import { Link } from "react-router-dom";

const BlogSidebar = ({ blogs = [] }) => (
  <aside className="border border-white/10 bg-cynos-card p-5 h-fit">
    <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-cynos-red">Related Reads</h3>
    <div className="mt-5 space-y-4">
      {blogs.map((blog) => (
        <Link key={blog.id} to={`/blog/${blog.slug}`} className="block border-b border-white/10 pb-4 last:border-b-0 last:pb-0">
          <div className="font-bold uppercase leading-tight hover:text-cynos-red">{blog.title}</div>
          <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{blog.category || "CYNOS"}</div>
        </Link>
      ))}
    </div>
  </aside>
);

export default BlogSidebar;
